import { Form, Select, TreeSelect } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FolderDataNode } from '../../../../../../../../model/elements';
import { Connection, Project } from '../../../../../../../../model/entities';
import stringService from '../../../../../../../../services/StringService';

const EditableCell: React.FC<Props> = ({
    editing,
    connection,
    identifier,
    dataIndex,
    title,
    index,
    children,
    projects,
    folderNodes,
    onProjectChange,
    onFolderChange,
    ...restProps
}) => {
    return (
        <td {...restProps}>
            {editing
                ? getFormItem(identifier, connection, dataIndex, projects, folderNodes, onProjectChange, onFolderChange)
                : children}
        </td>
    );
};
export default EditableCell;

const getFormItem = (
    identifier: string,
    connection: Connection,
    dataIndex: any,
    projects: Project[],
    folderNodes: FolderDataNode[],
    onProjectChange: (projectId: string) => Promise<void>,
    onFolderChange: (folderId: string) => Promise<void>,
) => {
    switch (identifier) {
        case 'project':
            return (
                <Form.Item name={dataIndex} style={{ margin: 0 }}>
                    <Select
                        showSearch
                        filterOption={stringService.filterOptions}
                        onChange={connection.target?.provider === 'ACONEX' ? () => {} : onProjectChange}
                    >
                        {projectOptions(projects)}
                    </Select>
                </Form.Item>
            );
        case 'folder':
            return connection.target?.provider === 'ACONEX' ? (
                <Form.Item name={dataIndex} style={{ margin: 0 }}>
                    <Select>{folderOptions()}</Select>
                </Form.Item>
            ) : (
                <Form.Item name={dataIndex} style={{ margin: 0 }}>
                    <TreeSelect
                        style={{ width: '100%' }}
                        dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                        treeData={folderNodes}
                        loadData={(folderNode) => onFolderChange(folderNode.folder.id)}
                    />
                </Form.Item>
            );

        default:
            break;
    }
};

const projectOptions = (projects: Project[]) =>
    projects
        .sort((a, b) => stringService.sort(a.name, b.name))
        .map((project) => (
            <Select.Option key={project.id} value={project.id}>
                {project.name}
            </Select.Option>
        ));

const folderOptions = () => (
    <Select.Option key="temporaryFiles" value="temporaryFiles">
        <FormattedMessage id="connectionLink.targets.temporaryFiles" />
    </Select.Option>
);
interface Props extends React.HTMLAttributes<HTMLElement> {
    connection: Connection;
    editing: boolean;
    identifier: string;
    dataIndex: string;
    title: any;
    index: number;
    children: React.ReactNode;
    projects: Project[];
    folderNodes: FolderDataNode[];
    onProjectChange: (projectId: string) => Promise<void>;
    onFolderChange: (folderId: string) => Promise<void>;
}
